import React from "react";
import Select, { components } from "react-select";
import './SecondaryFilterBar.scss';

const SecondaryFilterBar = ({ searchParams, setFilters }) => {
  const costOptions = [
    { value: 'any', label: 'Any' },
    { value: '1500-2500', label: '$1500-2500' },
    { value: '2501-3500', label: '$2501-3500' },
    { value: '3501-5000', label: '$3501-5000' },
    { value: '5001-', label: '$5001+' }
  ];

  const capacityOptions = [
    { value: 'any', label: 'Any' },
    { value: '1-6', label: '1-6 bed(s)' },
    { value: '7-20', label: '7-20 beds' },
    { value: '21-75', label: '21-75 beds' },
    { value: '76-', label: '76+ beds' }
  ];

  const dementiaCareOptions = [
    { value: 'any', label: 'Any' },
    { value: 'ALL', label: 'Yes' },
    { value: 'MILD', label: 'Mild-Only' },
    { value: 'NONE', label: 'No' }
  ];

  return (
    <div className="SecondaryFilterBar">
      <label>Filter by: </label>
      <Select
        className="filter-cost"
        options={costOptions}
        defaultValue={costOptions.find((option) => option.value === searchParams.get('cost')) || null}
        placeholder="Monthly Price Range"
        onChange={(selectedOption) => {
          setFilters({ cost: selectedOption.value });
        }}
        components={{
          SingleValue: ({ children, ...props }) => {
            return (
              <components.SingleValue {...props}>
                Price: {children}
              </components.SingleValue>
            );
          }
        }}
      />
      <Select
        options={capacityOptions}
        defaultValue={capacityOptions.find((option) => option.value === searchParams.get('capacity')) || null}
        placeholder="Facility Size"
        onChange={(selectedOption) => {
          setFilters({ capacity: selectedOption.value });
        }}
        components={{
          SingleValue: ({ children, ...props }) => {
            return (
              <components.SingleValue {...props}>
                Capacity: {children}
              </components.SingleValue>
            );
          }
        }}
      />
      <Select
        options={dementiaCareOptions}
        defaultValue={dementiaCareOptions.find((option) => option.value === searchParams.get('dementia')) || null}
        placeholder="Dementia Care"
        onChange={(selectedOption) => {
          setFilters({ dementia: selectedOption.value });
        }}
        components={{
          SingleValue: ({ children, ...props }) => {
            return (
              <components.SingleValue {...props}>
                Dementia Care: {children}
              </components.SingleValue>
            );
          }
        }}
      />
    </div>
  );
};

export default SecondaryFilterBar;
